<template>
  <div>
    <v-card>
      <v-card-title>
        Hasil Kuesioner
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="ml-4" @click="openLaporanModal">
          Laporan
        </v-btn>
        <v-btn color="purple" dark class="ms-2" @click="onDownloadAnggota">
          Download
        </v-btn>
      </v-card-title>

      <v-row class="mx-4 my-4">
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari Nama"
            single-line
            outlined
            dense
            hide-details
            @keyup.enter="getDataFromApi"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="list_data"
        :options.sync="options"
        :server-items-length="totalData"
        :loading="loading"
        class="elevation-1"
        :single-select="true"
        show-select
      >
        <template #[`item.created_at`]="{ item }">
          <div>{{ getCurrentDate(item.created_at) }}</div>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="mt-4">
      <PsikologisHasilJawaban
        v-if="selected.length > 0"
        :id="selected[0].id"
        ref="mychild"
        :key="childKey"
      />
    </v-card>

    <LaporanLoyalitasSelect ref="modalAnggota" v-model="dialogAnggota" />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import PsikologisHasilService from "../../services/PsikologisHasilService";
import PsikologisHasilJawaban from "./PsikologisHasilJawaban.vue";
import moment from "moment";
import CommonService from "../../services/CommonService";
import LaporanLoyalitasSelect from "./LaporanLoyalitasSelect.vue";

// Refs for template elements
const mychild = ref(null);
const modalAnggota = ref(null);
const dialogAnggota = ref(false);

// Reactive state
const childKey = ref(0);
const selected = ref([]);
const search = ref("");
const headers = ref([
  { text: "No", align: "start", sortable: false, value: "no" },
  { text: "Nama", value: "nama_user", sortable: false },
  { text: "Skor", value: "skor", sortable: false },
  { text: "Tanggal", value: "created_at", sortable: false },
]);
const isFirst = ref(false);
const totalData = ref(0);
const list_data = ref([]);
const loading = ref(true);
const options = ref({ itemsPerPage: 10 });

// Watchers
watch(
  selected,
  () => {
    if (selected.value?.length > 0) {
      childKey.value++;
    }
  },
  { deep: true },
);

watch(
  options,
  () => {
    if (isFirst.value) {
      getDataFromApi();
    }
  },
  { deep: true },
);

// Lifecycle Hooks
onMounted(() => {
  getDataFromApi();
});

// Methods
const getDataFromApi = () => {
  const { page, itemsPerPage } = options.value;
  loading.value = true;
  PsikologisHasilService.getList(page, itemsPerPage, search.value, 2)
    .then((res) => {
      list_data.value = res.data.list_data;
      totalData.value = res.data.total;
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      loading.value = false;
      isFirst.value = true;
    });
};

const getCurrentDate = (tanggal) => {
  return moment(tanggal).format("DD/MM/YYYY HH:mm");
};

function openLaporanModal() {
  modalAnggota.value.getDataFromApi();
  dialogAnggota.value = true;
}

function onDownloadAnggota() {
  PsikologisHasilService.downloadLoyalitas(search.value)
    .then((res) => {
      console.log(res);

      CommonService.showSuccessToast("Report sedang disiapkan. Mohon menunggu");
    })
    .catch((err) => {
      this.isProgressBarShow = false;
      CommonService.showErrorToast("Gagal download report. Coba lagi");
      console.log(err);
    });
}
</script>
